import React, { Fragment, useContext, useEffect } from 'react';

import {
    Paper,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@material-ui/core';

import { TablesContext } from '../TablesContext';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    },
    selector: {
        width: '100%'
    },
    notables: {
        padding: "16px"
    }    
}));

export const TableSelector = (props) => {
    const classes = useStyles();

    const {
        state,
        getTableDefinitions,
        setSelectedTableIndex
    } = useContext(TablesContext);

    const itemSelectHandler = (e) => {
        const index = e.target.value;
        setSelectedTableIndex(index);
    }

    useEffect(() => {
        getTableDefinitions(props.tableValueType);
    }, [props.tableValueType]);

    return (
        <Fragment>
            {state.tables.length > 0 ?
                <Paper className={classes.root}>
                    <FormControl className={classes.selector}>
                        <InputLabel>All tables</InputLabel>
                        <Select value={state.selectedTableIndex} onChange={itemSelectHandler}>
                            {state.tables && state.tables.map((table, index) => (
                                <MenuItem key={index} value={index}>{table.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Paper>                 
                :               
                <Paper className={classes.notables}>
                    <Typography variant="h6">
                        No tables available.
                    </Typography>
                    <Typography variant="body1">
                        There's no tables avaiable at this time.
                    </Typography>
                </Paper>
            }
        </Fragment>
    );
}